<template>
    <div class="content-box">
      <div class="element-wrapper">
        <div class="element-box">
          <h5 class="form-header">Listado de Recetas</h5>
          <!-------------------- START - Controles arriba de tabla-------------------->
          <div class="controls-above-table">
            <div class="row">
              <div class="col-sm-6">
                <router-link class="btn btn-sm btn-success" :to="{ name: 'cat-receta-nuevo', params: {} }">
                  <i class="fa fa-plus"></i>
                  Nueva Receta
                </router-link>
              </div>
              <div class="col-sm-6">
                <form action="#" class="form-inline justify-content-sm-end">
                  <input
                    class="form-control form-control-sm rounded bright"
                    placeholder="Buscar..."
                    @keydown.enter="searchData()"
                    v-model="searchText"
                    type="text"
                  />
                  <select
                    class="form-control form-control-sm rounded bright"
                    @change="searchData()"
                    v-model="filterEstado"
                  >
                    <option value>Todos los Estados</option>
                    <option value="A">Abierto</option>
                    <option value="B">Pendiente</option>
                    <option value="C">Cerrado</option>
                    <option value="9">Anulado</option>
                  </select>
                  <div class="input-group-append">
                    <button
                      class="btn btn-link btn-sm"
                      type="button"
                      @click="searchData()"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                    <button
                      class="btn btn-link btn-sm"
                      type="button"
                      @click="clearSearch()"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-3">
                <label class="mb-0"><small>Fecha Inicio:</small></label>
                <input
                  type="date"
                  class="form-control form-control-sm rounded bright"
                  v-model="filterFechaInicio"
                  @change="searchData()"
                >
              </div>
              <div class="col-sm-3">
                <label class="mb-0"><small>Fecha Fin:</small></label>
                <input
                  type="date"
                  class="form-control form-control-sm rounded bright"
                  v-model="filterFechaFin"
                  @change="searchData()"
                >
              </div>
            </div>
          </div>

          <!-------------------- END - Controles arriba de tabla-------------------->
          <div class="table-responsive mb-2">
            <!-------------------- Tabla de REsultados -------------------->
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Producto</th>
                  <th class="text-right">Fecha de Inicio</th>
                  <th class="text-right">Fecha de Fin</th>
                  <th class="text-center">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="receta in recetas.results" @click="rowClick(receta)">
                  <td>{{ receta.numero }}</td>
                  <td>({{ receta.producto_obj.sku }}) {{ receta.producto_obj.nombre }}</td>
                  <td class="text-right">{{ receta.fecha_inicio }}</td>
                  <td class="text-right">{{ receta.fecha_fin }}</td>
                  <td class="text-center">
                    <span
                      :class="{
                        'badge bg-success text-white': receta.estado === 'A',
                        'badge bg-warning text-black': receta.estado === 'B',
                        'badge bg-secondary text-white': receta.estado === 'C',
                        'badge bg-danger text-white': receta.estado === '9',
                      }"
                    >{{ estadoLabel(receta.estado) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-------------------- END - Basic Table -------------------->
          </div>
          <PaginationComponent :currentPage="currentPage" :data="recetas" @pagechanged="onPageChange" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import PaginationComponent from "@/components/utils/PaginationComponent";
  import RecetaService from "@/services/catalogos/RecetaService";
  import Notifications from "@/notifications/notifications";
  import DynamicService from "@/services/commons/DynamicService";
  
  export default {
    components: {
      PaginationComponent,
    },
    data() {
      return {
        recetas: [],
        currentPage: 1,
        filterEstado: "",
        searchText: "",
        filterFechaInicio: "",
        filterFechaFin: "",
      };
    },
    mounted() {
      this.refreshData({
          page:1,
        });
    },
    methods: {
      refreshData(params){
        RecetaService.fetch(params).then(response => {
          this.recetas = response.data;
          if(this.recetas.count === 0){
            this.$toast.warning("No se encontraron registros, cree uno para iniciar la lista.", "Advertencia", {
              position: 'topRight'
            });
          }
        })
      },
      estadoLabel(estado){
        const labels = { A: 'Abierto', B: 'Pendiente', C: 'Cerrado', '9': 'Anulado' };
        return labels[estado] || estado;
      },
      buildFilterParams(page){
        return {
          page: page,
          "filter[search]": this.searchText,
          estado: this.filterEstado,
          fecha_inicio: this.filterFechaInicio,
          fecha_fin: this.filterFechaFin,
        };
      },
      rowClick(row) {
        let self = this;
        if (event.ctrlKey) {
          let routeUrl = this.$router.resolve({
            name: "cat-receta-editar",
            params: { id: row.id },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          self.$router.push({
            name: "cat-receta-editar",
            params: { id: row.id },
          });
        }
      },
      onPageChange(page) {
        this.currentPage = page;
        this.refreshData(this.buildFilterParams(this.currentPage));
      },
      clearSearch(){
        this.searchText = "";
        this.filterEstado = "";
        this.filterFechaInicio = "";
        this.filterFechaFin = "";
        this.currentPage = 1;
        this.refreshData(this.buildFilterParams(1));
      },
      searchData(){
        this.currentPage = 1;
        this.refreshData(this.buildFilterParams(1));
      },
    },
  };
  </script>
  